module.exports = __webpack_public_path__ + "static/media/constPicTwo.bd86b1d3.jpeg";